// extracted by mini-css-extract-plugin
export var csatScore = "_m6-5";
export var header = "_m6-1";
export var panelWrapper = "_m6-2";
export var postPreview = "_m6-3";
export var rightContent = "_m6-0";
export var wrappingText = "_m6-4";